import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DndContext, DragEndEvent, DragOverlay, DragStartEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { AppSidebar } from './AppSidebar';
import { cn } from '@/lib/utils';

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeWorkflow, setActiveWorkflow] = useState<any>(null);
  
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // 5px movement required to start drag
      },
    })
  );

  const handleDragStart = (event: DragStartEvent) => {
    const { active } = event;
    if (active.data.current?.type === 'workflow') {
      setActiveWorkflow(active.data.current.workflow);
    }
  };

  const handleDragEnd = (event: DragEndEvent) => {
    setActiveWorkflow(null);
    // The actual drop handling will be done in WorkflowList
    // This is just to clear the active workflow state
  };

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <div className="flex h-screen overflow-hidden bg-background">
        {/* Sidebar - Reduced width: 200px expanded, 48px collapsed */}
        <AppSidebar 
          collapsed={sidebarCollapsed} 
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
        />

        {/* Main Content Area */}
        <div className="flex flex-col flex-1 overflow-hidden">
          {/* Page Content */}
          <main className="flex-1 overflow-hidden">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Drag Overlay */}
      <DragOverlay>
        {activeWorkflow ? (
          <div className="bg-background border rounded-lg p-4 shadow-lg opacity-90">
            <div className="font-medium">{activeWorkflow.name}</div>
            {activeWorkflow.description && (
              <div className="text-sm text-muted-foreground line-clamp-1">
                {activeWorkflow.description}
              </div>
            )}
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
}
